// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1WcW4","col":"styles_col__261lc","fulfillmentStatus":"styles_fulfillmentStatus__2e78u","emailCol":"styles_emailCol__2FDUg"};